module.exports = __webpack_public_path__ + "img/logo.e1bd145c.svg";